module.exports = __webpack_public_path__ + "static/media/mockups.233ee447.png";